/* eslint-disable */
export default {
  noActiveCalls: 'Keine aktiven Anrufe',
  noCalls: 'Keine Treffer gefunden.',
  currentCall: 'Aktueller Anruf',
  ringCall: 'Anruf wird getätigt',
  onHoldCall: 'Anruf wird gehalten',
  historyCalls: 'Vergangene Anrufe',
  otherDeviceCall: 'Aktuelle Gespräche auf meinen anderen Geräten',
  searchPlaceholder: 'Suchen...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
